module.exports = __webpack_public_path__ + "static/Proposal-Boards2-1ee21b13887f35342d6da1efff30ca5a.png";